export const ADMIN_TOKEN = 'admin_token';
export const REFRESH_TOKEN = 'admin_refresh_token';
export const CANDIDATE_TOKEN = 'candidate_token';
export const ADMIN_USER_DETAIL='admin_user_detail'
export const CANDIDATE_LOGO='candidate_logo'
export const CANDIDATE_ID='candidate_id'
export const CANDIDATE_DETAIL='candidate_detail'
export function logout() {
  clearUserToken();
  localStorage.clear();
}

export function setAdminToken(TOKEN) {
  localStorage.setItem(ADMIN_TOKEN, TOKEN);
}
export function setAdminRefreshToken(TOKEN) {
  localStorage.setItem(REFRESH_TOKEN, TOKEN);
}
export function getAdminToken() {
  return localStorage.getItem(ADMIN_TOKEN);
}
export function getAdminRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN);
}
export function setAdminDetail(TOKEN) {
  return localStorage.setItem(ADMIN_USER_DETAIL, JSON.stringify(TOKEN));
}
export function getAdminDetail() {
  let adminDetail=localStorage.getItem(ADMIN_USER_DETAIL);
  return JSON.parse(adminDetail)
}
export function setCandidateLogo(logo) {
  localStorage.setItem(CANDIDATE_LOGO, logo);
}
export function getCandidateLogo() {
  return localStorage.getItem(CANDIDATE_LOGO);
}

export function setCandidateId(id) {
  localStorage.setItem(CANDIDATE_ID, id);
}
export function getCandidateId() {
  return localStorage.getItem(CANDIDATE_ID);
}
export function setCandidateDetail(item) {
  localStorage.setItem(CANDIDATE_DETAIL, item);
}
export function getCandidateDetail() {
  let candidateDetail= localStorage.getItem(CANDIDATE_DETAIL);
  return JSON.parse(candidateDetail)
}
export function clearUserToken() {
  localStorage.removeItem(ADMIN_TOKEN);
}

export function isAdminLoggedIn() {
  const accessToken = getAdminToken();
  return !!accessToken;
}

export function setCandidateToken(TOKEN) {
  localStorage.setItem(CANDIDATE_TOKEN, TOKEN);
}
export function getCandidateToken() {
  return localStorage.getItem(CANDIDATE_TOKEN);
}
export function isCandidateLoggedIn() {
  const accessToken = getCandidateToken();
  return !!accessToken;
}

export function clearCandidateToken() {
  localStorage.removeItem('tabchangecount');
  localStorage.removeItem('userID');
  localStorage.removeItem('candidate_Email');
  localStorage.removeItem('candidatetestStore');
  localStorage.removeItem('testid');
  localStorage.removeItem('TimerStore');
  localStorage.removeItem(CANDIDATE_TOKEN);
  localStorage.removeItem('userdetail');
  localStorage.removeItem('candidateSidebarStore');
  localStorage.removeItem('testName');
  localStorage.removeItem(CANDIDATE_DETAIL);
  localStorage.removeItem(CANDIDATE_ID);

}
